import { InputBase, InputAccountingTargetController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Select component for Accounting Targets.
 * @example
 * ```html
 * <salaxy-input-accounting-target></salaxy-input-accounting-target>
 * ```
 */
export class InputAccountingTarget extends ComponentBase {

    /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
    public require = {
      model: "ngModel",

      form: "?^^form",
  };

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = InputBase.crudBindings;

    /** Uses the InputAccountingTargetController */
    public controller = InputAccountingTargetController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/form-controls/InputAccountingTarget.html";
}
